import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ChatModal from './components/ChatModal';
import iconTema from '../src/assets/icon-Tema.png'

function App() {
  const chatModalRef = useRef(null);

  const handleOpenChat = () => {
    if (chatModalRef.current) {
      chatModalRef.current.openModal();
    }
  };
  return (
    <div className="App">
      <Header onOpenChat={handleOpenChat} />

      {/* Hero Section */}
      <section className="relative gradient-bg text-white section-padding pt-32 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2072&q=80"
            alt="Futuristic Technology Background"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-somax-green/90 to-green-600/90"></div>
        </div>

        {/* Floating Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-somax-yellow/20 rounded-full blur-xl floating-animation"></div>
        <div className="absolute bottom-20 right-10 w-32 h-32 bg-white/10 rounded-full blur-2xl floating-animation" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 bg-somax-yellow/30 rounded-full blur-lg floating-animation" style={{ animationDelay: '2s' }}></div>

        <div className="container-custom text-center relative z-10">
          <div className="mb-8">
            <div className="inline-block p-4 bg-white/10 backdrop-blur-sm rounded-2xl mb-6">
              <img
                src={iconTema}
                alt="Digital Innovation"
                className="w-16 h-16 mx-auto rounded-lg"
              />
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-shadow-lg">
            Realize Seus Sonhos com a <span className="text-somax-yellow glow-text">Somax</span>
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-green-100 max-w-3xl mx-auto leading-relaxed">
           Imóveis com as melhores condições do mercado. 
            <span className="text-somax-yellow font-semibold">Planos inteligentes e parcelas que cabem no seu bolso!</span>
          
          </p>
           <div className="relative bg-white/95 backdrop-blur-sm text-somax-dark rounded-2xl p-8 card-hover box-shadow-futuristic border border-white/20 overflow-hidden">
                {/* Card Background Image */}
                <div className="absolute inset-0 opacity-10">
                  <img
                    src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                    alt="Modern House"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>

                {/* Gradient Overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-somax-gray/5 rounded-2xl"></div>

                <div className="relative z-10">
                  <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
                    <svg className="w-12 h-12 text-somax-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-gradient">Imóveis</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Conquiste a casa própria e garanta segurança para sua família.
                  </p>
                  <div className="btn-primary inline-block group-hover:bg-green-600 group-hover:shadow-2xl">
                    Ver Imóveis
                  </div>
                </div>
              </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12">
            {/* Card Carro */}
            {/* <Link to="/carro" className="group">
              <div className="relative bg-white/95 backdrop-blur-sm text-somax-dark rounded-2xl p-8 card-hover box-shadow-futuristic border border-white/20 overflow-hidden">
          
                <div className="absolute inset-0 opacity-10">
                  <img
                    src="https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                    alt="Modern Car"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>

            
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-somax-green/5 rounded-2xl"></div>

                <div className="relative z-10">
                  <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
                   <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-somax-green" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#fe7815" stroke-width="1.5"><path stroke-linecap="round" stroke-linejoin="round" d="M8 10h8m-9 4h1m8 0h1"/><path d="M3 18v-6.59a2 2 0 0 1 .162-.787l2.319-5.41A2 2 0 0 1 7.319 4h9.362a2 2 0 0 1 1.838 1.212l2.32 5.41a2 2 0 0 1 .161.789V18M3 18v2.4a.6.6 0 0 0 .6.6h2.8a.6.6 0 0 0 .6-.6V18m-4 0h4m14 0v2.4a.6.6 0 0 1-.6.6h-2.8a.6.6 0 0 1-.6-.6V18m4 0h-4M7 18h10"/></g></svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-gradient">Carros</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Conquiste sua liberdade com o carro dos seus sonhos.
                    <span className="font-semibold text-somax-green">Parcelas a partir de R$ 200.</span>
                  </p>
                  <div className="btn-primary inline-block group-hover:bg-green-600 group-hover:shadow-2xl">
                    Ver Carros
                  </div>
                </div>
              </div>
            </Link>  */}

           
            {/* <Link to="/caminhao" className="group">
             Card Caminhão
              <div className="relative bg-white/95 backdrop-blur-sm text-somax-dark rounded-2xl p-8 card-hover box-shadow-futuristic border border-white/20 overflow-hidden">
          
                <div className="absolute inset-0 opacity-10">
                  <img
                    src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                    alt="Modern Truck"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>

            
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-somax-yellow/5 rounded-2xl"></div>

                <div className="relative z-10">
                  <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-12 h-12 text-somax-green" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="#fe7815" stroke-linecap="round" stroke-width="1.5"><path stroke-linejoin="round" stroke-miterlimit="1.5" d="M8 19a2 2 0 1 0 0-4a2 2 0 0 0 0 4m10 0a2 2 0 1 0 0-4a2 2 0 0 0 0 4"/><path d="M10.05 17H15V6.6a.6.6 0 0 0-.6-.6H1m4.65 11H3.6a.6.6 0 0 1-.6-.6v-4.9"/><path stroke-linejoin="round" d="M2 9h4"/><path d="M15 9h5.61a.6.6 0 0 1 .548.356l1.79 4.028a.6.6 0 0 1 .052.243V16.4a.6.6 0 0 1-.6.6h-1.9M15 17h1"/></g></svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-gradient">Caminhões</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Faça seu negócio crescer com caminhões novos.
                    <span className="font-semibold text-somax-yellow">Invista no seu futuro.</span>
                  </p>
                  <div className="btn-primary inline-block group-hover:bg-green-600 group-hover:shadow-2xl">
                    Ver Caminhões
                  </div>
                </div>
              </div>
            </Link>  */}

            {/* Card Imóvel */}
            {/* <Link to="/imovel" className="group">
              <div className="relative bg-white/95 backdrop-blur-sm text-somax-dark rounded-2xl p-8 card-hover box-shadow-futuristic border border-white/20 overflow-hidden">
            
                <div className="absolute inset-0 opacity-10">
                  <img
                    src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80"
                    alt="Modern House"
                    className="w-full h-full object-cover rounded-2xl"
                  />
                </div>

             
                <div className="absolute inset-0 bg-gradient-to-br from-transparent to-somax-gray/5 rounded-2xl"></div>

                <div className="relative z-10">
                  <div className="inline-block p-3 bg-somax-green/20 rounded-2xl mb-6 backdrop-blur-sm">
                    <svg className="w-12 h-12 text-somax-green" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold mb-4 text-gradient">Imóveis</h3>
                  <p className="text-gray-600 mb-6 leading-relaxed">
                    Conquiste a casa própria e garanta segurança para sua família.
                  </p>
                  <div className="btn-primary inline-block group-hover:bg-green-600 group-hover:shadow-2xl">
                    Ver Imóveis
                  </div>
                </div>
              </div>
            </Link> */}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="relative section-padding bg-gradient-to-br from-somax-light to-white overflow-hidden">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <img
            src="https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2025&q=80"
            alt="Technology Pattern"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Floating Geometric Elements */}
        <div className="absolute top-10 right-10 w-24 h-24 border-2 border-somax-green/20 rounded-lg rotate-45 floating-animation"></div>
        <div className="absolute bottom-10 left-10 w-16 h-16 bg-somax-yellow/10 rounded-full floating-animation" style={{ animationDelay: '1.5s' }}></div>

        <div className="container-custom relative z-10">
          <div className="text-center mb-12">
            <div className="inline-block p-3 bg-somax-green/10 rounded-2xl mb-4">
              <img
                src={iconTema}
                alt="Innovation Icon"
                className="w-12 h-12 rounded-lg"
              />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-somax-dark mb-4">
              Por que escolher a <span className="text-gradient">Somax</span>?
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Mais de 10 anos realizando sonhos com <span className="font-semibold text-somax-green">transparência e confiança</span>
            </p>
            <div className="mt-8">
              <img
                src="https://obkphspftyoddbglfnrz.supabase.co/storage/v1/object/public/image/Maquinas/equipe-invest.jpg"
                alt="Equipe Somax"
                className="rounded-2xl shadow-xl mx-auto max-w-full md:max-w-3xl"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-somax-green to-green-600 rounded-2xl flex items-center justify-center mx-auto shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-somax-yellow rounded-full opacity-80 group-hover:scale-125 transition-all duration-300"></div>
              </div>
              <h3 className="text-xl font-bold text-somax-dark mb-3 group-hover:text-somax-green transition-colors duration-300">Aprovação Rápida</h3>
              <p className="text-gray-600 leading-relaxed">Análise em até <span className="font-semibold text-somax-green">24 horas</span> com documentação simplificada</p>
            </div>

            <div className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-somax-yellow to-yellow-600 rounded-2xl flex items-center justify-center mx-auto shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110">
                  <svg className="w-10 h-10 text-somax-dark" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                  </svg>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-somax-green rounded-full opacity-80 group-hover:scale-125 transition-all duration-300"></div>
              </div>
              <h3 className="text-xl font-bold text-somax-dark mb-3 group-hover:text-somax-yellow transition-colors duration-300">Melhores Taxas</h3>
              <p className="text-gray-600 leading-relaxed">Condições especiais e <span className="font-semibold text-somax-yellow">parcelas que cabem</span> no seu orçamento</p>
            </div>

            <div className="text-center group">
              <div className="relative mb-6">
                <div className="w-20 h-20 bg-gradient-to-br from-somax-gray to-gray-600 rounded-2xl flex items-center justify-center mx-auto shadow-xl group-hover:shadow-2xl transition-all duration-300 group-hover:scale-110">
                  <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 12h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-somax-yellow rounded-full opacity-80 group-hover:scale-125 transition-all duration-300"></div>
              </div>
              <h3 className="text-xl font-bold text-somax-dark mb-3 group-hover:text-somax-gray transition-colors duration-300">Suporte Total</h3>
              <p className="text-gray-600 leading-relaxed">Acompanhamento completo desde a <span className="font-semibold text-somax-gray">aprovação até a contemplação</span></p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="relative section-padding bg-gradient-to-r from-somax-dark via-gray-900 to-somax-dark overflow-hidden">
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2074&q=80"
            alt="Future Technology"
            className="w-full h-full object-cover opacity-20"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-somax-dark/90 via-gray-900/80 to-somax-dark/90"></div>
        </div>

        {/* Animated Particles */}
        <div className="absolute top-20 left-20 w-2 h-2 bg-somax-green rounded-full floating-animation opacity-60"></div>
        <div className="absolute top-40 right-32 w-3 h-3 bg-somax-yellow rounded-full floating-animation opacity-40" style={{ animationDelay: '2s' }}></div>
        <div className="absolute bottom-32 left-40 w-2 h-2 bg-white rounded-full floating-animation opacity-50" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-20 right-20 w-4 h-4 border border-somax-green/30 rounded-full floating-animation" style={{ animationDelay: '3s' }}></div>

        <div className="container-custom text-center relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="inline-block p-4 bg-somax-green/10 rounded-3xl mb-6 backdrop-blur-sm border border-somax-green/20">
              <img
                src={iconTema}
                alt="Digital Innovation"
                className="w-16 h-16 rounded-2xl mx-auto"
              />
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6 glow-text">
              Pronto para realizar seu <span className="text-gradient bg-gradient-to-r from-somax-green to-somax-yellow bg-clip-text text-transparent">sonho</span>?
            </h2>
            <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto leading-relaxed">
              Fale conosco agora e descubra como podemos ajudar você a conquistar seu <span className="text-white font-semibold">imóvel</span> dos sonhos!
            </p>
            <button
              onClick={handleOpenChat}
              className="btn-primary text-lg px-10 py-4 bg-gradient-to-r from-somax-green to-green-600 hover:from-green-600 hover:to-somax-green transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-somax-green/25 border-2 border-transparent hover:border-somax-green/30 backdrop-blur-sm"
            >
              <span className="flex items-center gap-3">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
                Falar com Especialista
                <div className="w-2 h-2 bg-somax-yellow rounded-full animate-pulse"></div>
              </span>
            </button>
          </div>
        </div>
      </section>
     <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3838.2879952511803!2d-48.046585524868874!3d-15.841453784805537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a328bd8bc60c1%3A0xd082313d70393121!2sTaguatinga%20Shopping!5e0!3m2!1spt-BR!2sbr!4v1760663397520!5m2!1spt-BR!2sbr" width="100%" style={{border:"0",}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      <Footer />
      <ChatModal ref={chatModalRef} />
    </div>
  );
}

export default App;